export default "__VITE_ASSET__KliAf7Ql__"